import { css } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';

export const styles = css`
  :host {
    display: block;
  }

  form {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
  }

  .footer-subscrube-input {
    width: 100%;
    flex: 1 1 70%;
    box-sizing: border-box;
    padding: ${pxToRem(8)} ${pxToRem(8)} ${pxToRem(8)} ${pxToRem(36)};
    margin: 0;
    border: 3px solid #66c05d;
    border-right: none;
    border-radius: 0;
  }

  .footer-subscrube-input:focus {
    outline: none;
  }

  .footer-subscrube-input:focus-visible {
    outline: 3px solid blueviolet;
  }

  .footer-subscrube-input.focus-visible {
    outline: 3px solid blueviolet;
  }

  label {
    position: absolute;
    top: 50%;
    left: 15px;
    width: 16px;
    height: 12px;

    font-size: 0;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDE2IDEyIj4gICAgPHBhdGggZmlsbD0iI0IyQjJCMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMS4xODIgMGw2LjYwNiA2LjZMMTQuMzg5IDBIMS4xODJ6TTguNzMgNy41NWwtLjk0My45NDItLjk0MS0uOTQyTDAgLjcwNXYxMC41MTNsNC42OTMtNC42OTIuOTQyLjk0Mi00LjQ1OCA0LjQ1OGgxMy4yMjFMOS45NCA3LjQ2OGwuOTQyLS45NDIgNC42OTIgNC42OTZWLjcwNUw4LjczIDcuNTV6Ii8+PC9zdmc+);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
  }

  .submit-button {
    --button-bg: #66c05d;
    --button-hover-bg: #4ba842;
    --button-color: #fff;

    --button-border-radius: 0;

    display: flex;
  }

  .submit-button-inner {
    height: 100%;
    padding: 10px;
    margin: 0;
    border: none;

    line-height: 13px;
    font-size: 11px;
  }

  .error-text {
    position: absolute;
    font-size: 10px;
    bottom: 5px;
    margin: 0;
    left: 15px;
    color: #ff0000;
  }

  .subscrube-popup-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1 1 100%;

    text-align: center;
  }

  .title {
    margin-bottom: ${pxToRem(20)};

    color: #66c05d;

    font-size: ${pxToRem(40)};
    font-weight: 600;
  }

  .description {
    font-size: ${pxToRem(14)};
    color: #ababab;
  }
`;
